module.exports = __webpack_public_path__ + "img/cost_banner.aa1f7582.png";